/* vd build 2026-10-09 v6 */
/* Viral Deals theme JS: header drawer, hero slider, product page, COD sheet. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function aed(cents) {
    var n = cents / 100, s = n.toFixed(2).replace(/\.00$/, '');
    var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'AED ' + p.join('.');
  }
  function aedNum(cents) { return aed(cents).replace('AED ', ''); }

  /* ---------- header drawer ---------- */
  function initDrawer() {
    var d = $('[data-vd-drawer]'); if (!d || d._vd) return; d._vd = 1;
    var openers = $$('[data-vd-menu-open]');
    function open() {
      closeSearch && closeSearch();
      d.hidden = false; document.documentElement.classList.add('vd-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
      setTimeout(function () { var x = $('.vd-x', d); x && x.focus({ preventScroll: true }); }, 60);
    }
    function close() {
      d.classList.remove('is-open'); document.documentElement.classList.remove('vd-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { d.hidden = true; }, reduceMotion ? 0 : 260);
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-vd-menu-close]', d).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !d.hidden) close(); });
  }

  /* ---------- announcement rotator ---------- */
  function initRotator() {
    $$('[data-vd-rotator]').forEach(function (r) {
      var m = $$('.vd-ann__m', r); if (m.length < 2 || r._vd) return; r._vd = 1; var i = 0;
      setInterval(function () { m[i].classList.remove('is-on'); i = (i + 1) % m.length; m[i].classList.add('is-on'); }, 4500);
    });
  }

  /* ---------- hero slider ---------- */
  function initHero() {
    $$('[data-vd-hero]').forEach(function (h) {
      if (h._vd) return; h._vd = 1;
      var s = $$('.vd-hero__s', h), dots = $$('.vd-dots button', h), i = 0, t;
      if (s.length < 2) return;
      function go(n) { s[i].classList.remove('is-on'); dots[i] && dots[i].classList.remove('is-on'); i = (n + s.length) % s.length; s[i].classList.add('is-on'); dots[i] && dots[i].classList.add('is-on'); }
      function auto() { clearInterval(t); if (!reduceMotion) t = setInterval(function () { go(i + 1); }, 5500); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); auto(); }); });
      var x0 = null;
      h.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      h.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); auto(); } x0 = null; });
      auto();
    });
  }

  /* ---------- product page ---------- */
  function initPdp() {
    var root = $('[data-vd-pdp]'); if (!root || root._vd) return; root._vd = 1;
    var P = JSON.parse($('[data-vd-json]', root).textContent);
    var endpoint = root.getAttribute('data-endpoint');
    var waNum = root.getAttribute('data-wa');
    var variant = P.variants.filter(function (v) { return v.id === P.selected; })[0] || P.variants[0];
    var tier = null, ofs = $$('[data-vd-offers] input', root);
    var vdItem = function (q) { return { id: variant.id, name: P.title, variant: P.defaultOnly ? undefined : variant.title, price: tier ? +(tier.p / 100 / tier.q).toFixed(4) : variant.price / 100, qty: tier ? tier.q : (q || 1), currency: 'AED' }; };
    window.vdProduct = vdItem(1);
    if (window.vdTrack) window.vdTrack('ViewContent', vdItem(1));
    var qty = 1;
    // offer tiers (quantity deals): prices come from the page; the server re-checks them
    function readTier() {
      var c = ofs.filter(function (i) { return i.checked; })[0];
      tier = c ? { n: +c.value, q: +c.getAttribute('data-q'), p: +c.getAttribute('data-p'), label: c.getAttribute('data-label'), el: c } : null;
      if (tier) qty = tier.q;
    }
    function tierCmp(inp) {
      var c = +inp.getAttribute('data-c'); if (c > 0) return c;
      return Math.max(variant.compare || 0, variant.price) * +inp.getAttribute('data-q');
    }
    readTier();
    var gal = $('[data-vd-gal]', root), dots = $$('[data-vd-dots] i', root), thumbs = $$('[data-vd-thumbs] button', root);

    // gallery
    var gn = $('[data-vd-gn]', root), gcount = gal ? $$('.vd-gal__s', gal).length : 0, gcur = 0;
    function setActive(n) {
      gcur = n;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      if (gn) gn.textContent = (n + 1) + ' / ' + gcount;
    }
    $$('[data-vd-gar]', root).forEach(function (b) { b.addEventListener('click', function () {
      var n = Math.max(0, Math.min(gcount - 1, gcur + +b.getAttribute('data-vd-gar')));
      gal.scrollTo({ left: n * gal.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(n);
    }); });
    if (gal) {
      gal.addEventListener('scroll', function () { var n = Math.round(gal.scrollLeft / gal.clientWidth); setActive(n); }, { passive: true });
      thumbs.forEach(function (b) { b.addEventListener('click', function () { var n = +b.getAttribute('data-i'); gal.scrollTo({ left: n * gal.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(n); }); });
    }
    function showMedia(id) {
      if (!gal || !id) return;
      var sl = $$('.vd-gal__s', gal), n = sl.findIndex(function (e) { return +e.getAttribute('data-media-id') === id; });
      if (n > -1) { gal.scrollTo({ left: n * gal.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(n); }
    }

    // render price, buttons, links
    function waLink() {
      var name = P.title + (P.defaultOnly ? '' : ' (' + variant.title + ')');
      var text = tier ? 'Hi, I want to order: ' + name + ' – ' + tier.label + ' – AED ' + aedNum(tier.p)
        : 'Hi, I want to order: ' + name + ' – AED ' + aedNum(variant.price * qty) + ', Qty ' + qty;
      return 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(text);
    }
    function render() {
      try { window.vdProduct = vdItem(qty); } catch (e) {}
      var dp = tier ? tier.p : variant.price, dc = tier ? tierCmp(tier.el) : variant.compare;
      var sale = dc > dp;
      $$('[data-vd-price]', root).forEach(function (e) { e.textContent = aed(dp); });
      $$('[data-vd-compare]', root).forEach(function (e) { e.hidden = !sale; e.textContent = sale ? aed(dc) : ''; });
      var sv = $('[data-vd-save]', root); if (sv) { sv.hidden = !sale; sv.textContent = sale ? 'You save ' + aed(dc - dp) + ' (' + Math.floor((dc - dp) * 100 / dc) + '%)' : ''; }
      ofs.forEach(function (inp) {
        var lab = inp.closest('.vd-of'), p = +inp.getAttribute('data-p'), c = tierCmp(inp);
        lab.classList.toggle('is-on', inp.checked);
        var s1 = $('[data-vd-ofc]', lab), s2 = $('[data-vd-ofsv]', lab);
        if (s1) { s1.hidden = !(c > p); s1.textContent = c > p ? aed(c) : ''; }
        if (s2) { s2.hidden = !(c > p); s2.textContent = c > p ? 'Save ' + aed(c - p) : ''; }
      });
      var so = $('[data-vd-soffer]', root); if (so) so.textContent = tier ? tier.label : '';
      var qi = $('[data-vd-qin]', root); if (qi && document.activeElement !== qi) qi.value = qty;
      var gb = $('[data-vd-gbadge]', root); if (gb) { gb.hidden = !sale; if (sale) gb.textContent = '-' + Math.floor((variant.compare - variant.price) * 100 / variant.compare) + '%'; }
      var sp = $('[data-vd-savepill]', root); if (sp) { sp.hidden = !sale; sp.textContent = sale ? 'Save ' + Math.floor((variant.compare - variant.price) * 100 / variant.compare) + '%' : ''; }
      $$('[data-vd-segprice]', root).forEach(function (e) { e.textContent = aed(variant.price * +e.getAttribute('data-vd-segprice')); });
      $$('[data-vd-buy]', root).forEach(function (b) { b.disabled = false; b.textContent = true ? 'Buy Now - Cash on Delivery' : 'Sold out'; });
      $$('[data-vd-wa]', root).forEach(function (a) { a.href = waLink(); });
      $$('[data-vd-optval]', root).forEach(function (e) { e.textContent = variant.options[+e.getAttribute('data-vd-optval')]; });
      // sheet
      var simg = $('[data-vd-simg]', root); if (simg && variant.image) simg.src = variant.image;
      var svar = $('[data-vd-svar]', root); if (svar) svar.textContent = P.defaultOnly ? '' : variant.title;
      var qv = $('[data-vd-qtyv]', root); if (qv) qv.textContent = qty;
      var tot = $('[data-vd-total]', root); if (tot) tot.textContent = aed(tier ? tier.p : variant.price * qty);
      $$('[data-vd-seg] button', root).forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-q') === qty); });
    }
    // options
    $$('[data-vd-opts] input', root).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var sel = $$('[data-vd-opts] fieldset', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = P.variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
        if (v) {
          variant = v; render(); showMedia(v.mediaId);
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        }
      });
    });
    // offers + quantity stepper
    ofs.forEach(function (inp) { inp.addEventListener('change', function () { readTier(); render(); }); });
    var qin = $('[data-vd-qin]', root);
    if (qin) {
      var setQ = function (commit) {
        var n = parseInt(qin.value, 10);
        if (!n || n < 1) { if (!commit) return; n = 1; }
        qty = Math.max(1, Math.min(P.maxQty, n)); if (commit) qin.value = qty; render();
      };
      qin.addEventListener('input', function () { setQ(false); });
      qin.addEventListener('change', function () { setQ(true); });
      qin.addEventListener('blur', function () { setQ(true); });
    }
    // quantity segment
    $$('[data-vd-seg] button', root).forEach(function (b) { b.addEventListener('click', function () { qty = +b.getAttribute('data-q'); render(); }); });

    // sticky bar: show once the main Buy Now scrolls out of view
    var mainBuy = $('.vd-buy', root), sticky = $('[data-vd-sticky]', root);
    if (mainBuy && sticky) {
      // scroll-based (an IntersectionObserver misses jumps from below the fold to above it)
      var shown = null, ticking = false;
      var upd = function () {
        ticking = false;
        var show = mainBuy.getBoundingClientRect().bottom < 0;
        if (show === shown) return; shown = show;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('vd-stk', show);
        $$('button, a', sticky).forEach(function (e) { e.tabIndex = show ? 0 : -1; });
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd); upd();
    }

    // sheet
    var sheet = $('[data-vd-sheet]', root), ov = $('.vd-ov', root), form = $('[data-vd-form]', root);
    var lastFocus = null;
    function openSheet() {
      if (false) return;
      lastFocus = document.activeElement;
      ov.hidden = false; sheet.hidden = false; document.documentElement.classList.add('vd-lock');
      if (window.vdTrack) window.vdTrack('InitiateCheckout', Object.assign(vdItem(qty), { event_id: 'vdic-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8) }));
      requestAnimationFrame(function () { ov.classList.add('is-on'); sheet.classList.add('is-on'); });
      setTimeout(function () { var n = $('#vd-name', sheet); n && n.focus({ preventScroll: true }); }, 250);
    }
    function closeSheet() {
      ov.classList.remove('is-on'); sheet.classList.remove('is-on'); document.documentElement.classList.remove('vd-lock');
      setTimeout(function () { ov.hidden = true; sheet.hidden = true; }, 220);
      lastFocus && lastFocus.focus && lastFocus.focus();
    }
    $$('[data-vd-buy]', root).forEach(function (b) { b.addEventListener('click', openSheet); });
    $$('[data-vd-buy-proxy]').forEach(function (b) { b.addEventListener('click', openSheet); });
    if (location.hash === '#buy' ) {
      history.replaceState(null, '', location.pathname + location.search);
      setTimeout(openSheet, 350);
    }
    $$('[data-vd-close]', root).forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    $$('[data-vd-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { if (tier) return; qty = Math.max(1, Math.min(P.maxQty, qty + +b.getAttribute('data-vd-qty'))); render(); });
    });

    // Lenient phone normaliser: same rules as the vd-cod worker. Returns "+<E.164 digits>" or null.
    var NSN = { '971': 9, '966': 9, '968': 8, '974': 8, '965': 8, '973': 8, '92': 10, '91': 10, '880': 10, '63': 10, '20': 10,
      '44': 10, '1': 10, '94': 9, '977': 10, '93': 9, '98': 10, '962': 9, '961': 8, '963': 9, '964': 10, '249': 9, '967': 9,
      '251': 9, '254': 9, '256': 9, '234': 10, '27': 9, '86': 11, '7': 10, '49': 11, '33': 9, '39': 10, '61': 9, '62': 11,
      '60': 9, '66': 9, '90': 10, '212': 9, '216': 8, '213': 9, '84': 9, '95': 9, '255': 9, '233': 9, '380': 9, '31': 9, '34': 9 };
    var CCS = Object.keys(NSN).sort(function (a, b) { return b.length - a.length; });
    function normPhone(raw, cc) {
      cc = String(cc || '').replace(/\D/g, ''); if (!NSN[cc]) cc = '971';
      var s = String(raw || '').trim(), d = s.replace(/\D/g, ''), plus = /^\+/.test(s), full;
      if (!plus && /^00[1-9]/.test(d)) { plus = true; d = d.slice(2); }
      if (d.replace(/^0+/, '').length < 7) return null;
      if (plus) full = d;
      else if (/^9715\d{8}$/.test(d)) full = d;
      else if (d.indexOf(cc) === 0 && d.length > (NSN[cc] || 9) && d.length - cc.length >= 6) full = d;
      else full = cc + d.replace(/^0+/, '');
      var k = CCS.filter(function (c) { return full.indexOf(c + '0') === 0 && full.length - c.length - 1 >= 6; })[0];
      if (k && k !== '39') full = k + full.slice(k.length + 1);
      if (full.length < 8 || full.length > 15) return null;
      return '+' + full;
    }
    window.vdNormPhone = normPhone;
    var ccSel = form.elements.cc, ccV = $('[data-vd-ccv]', form);
    function ccShow() {
      if (!ccSel || !ccV) return;
      var o = ccSel.options[ccSel.selectedIndex];
      ccV.innerHTML = ''; var f = document.createElement('span'); f.className = 'vd-cc__f'; f.textContent = o.getAttribute('data-f') || '';
      ccV.appendChild(f); ccV.appendChild(document.createTextNode('+' + ccSel.value));
      form.elements.phone.placeholder = ccSel.value === '971' ? '50 123 4567' : 'Phone number';
    }
    if (ccSel) {
      ccSel.addEventListener('change', function () { ccShow(); setErr('phone', ''); });
      // Typed a full "+92..." / "0092..." number? Move the dropdown to match (the typed number always wins).
      form.elements.phone.addEventListener('input', function () {
        var v = form.elements.phone.value.replace(/[\s\-().]/g, '').replace(/^00/, '+');
        if (v.charAt(0) !== '+') return;
        var d = v.slice(1), c = CCS.filter(function (x) { return d.indexOf(x) === 0; })[0];
        if (c && c !== ccSel.value && ccSel.querySelector('option[value="' + c + '"]')) { ccSel.value = c; ccShow(); }
      });
      ccShow();
    }
    function setErr(name, msg) {
      var e = $('[data-err="' + name + '"]', form); if (e) e.textContent = msg || '';
      var i = form.elements[name]; if (i) { i.classList.toggle('is-bad', !!msg); i.setAttribute('aria-invalid', msg ? 'true' : 'false'); }
    }
    function validate() {
      var f = form.elements, ok = true, first = null;
      var checks = [
        ['name', f.name.value.trim().length >= 2, 'Please enter your full name.'],
        ['phone', !!normPhone(f.phone.value, f.cc && f.cc.value), f.phone.value.trim() ? 'That number looks too short. Please check it and include all digits.' : 'Please enter your phone number.'],
        ['emirate', !!f.emirate.value, 'Please choose your emirate.'],
        ['area', f.area.value.trim().length >= 2, 'Please enter your area.'],
        ['address', f.address.value.trim().length >= 4, 'Please enter your street, building and flat.']
      ];
      checks.forEach(function (c) { setErr(c[0], c[1] ? '' : c[2]); if (!c[1]) { ok = false; first = first || c[0]; } });
      if (first) f[first].focus();
      return ok;
    }
    $$('input, select', form).forEach(function (i) { i.addEventListener('input', function () { setErr(i.name, ''); }); });

    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || !validate()) return;
      var f = form.elements, btn = $('[data-vd-submit]', form), fe = $('[data-vd-formerr]', form);
      fe.hidden = true; busy = true; btn.disabled = true; btn.textContent = 'Placing your order…';
      var body = { variantId: variant.id, quantity: qty, tier: tier ? tier.n : undefined, name: f.name.value.trim(), phone: normPhone(f.phone.value, f.cc && f.cc.value) || f.phone.value.trim(), cc: f.cc ? f.cc.value : '971', emirate: f.emirate.value,
        area: f.area.value.trim(), address: f.address.value.trim(), website: f.website.value,
        event_id: 'vdp-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10), source_url: location.href.split('#')[0] };
      try { var ids = window.vdFbIds ? window.vdFbIds() : {}; body.fbp = ids.fbp || undefined; body.fbc = ids.fbc || undefined; } catch (e2) {}
      var EMC = { 'Abu Dhabi': 'az', 'Dubai': 'du', 'Sharjah': 'sh', 'Ajman': 'aj', 'Umm Al Quwain': 'uq', 'Ras Al Khaimah': 'rk', 'Fujairah': 'fu' };
      var mp = window.vdMatch ? window.vdMatch({ phone: body.phone, name: body.name, city: body.emirate, state: EMC[body.emirate] || '' }) : null;
      fetch(endpoint.replace(/\/$/, '') + '/order', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (res) {
          if (!res || !res.ok) {
            if (res && res.fields) Object.keys(res.fields).forEach(function (k) { setErr(k, res.fields[k]); });
            fe.innerHTML = '';
            fe.appendChild(document.createTextNode((res && res.error) || 'Something went wrong. Please try again.'));
            var a = document.createElement('a'); a.href = waLink(); a.target = '_blank'; a.rel = 'noopener'; a.textContent = ' Order on WhatsApp instead';
            fe.appendChild(a); fe.hidden = false; return;
          }
          if (res.event_id) body.event_id = res.event_id;
          showDone(res.order, body);
        })
        .catch(function () {
          fe.textContent = 'No connection. Please check your internet and try again.';
          var a2 = document.createElement('a'); a2.href = waLink(); a2.target = '_blank'; a2.rel = 'noopener'; a2.textContent = ' Order on WhatsApp instead';
          fe.appendChild(a2); fe.hidden = false;
        })
        .finally(function () { busy = false; btn.disabled = false; btn.textContent = 'Confirm Order – Cash on Delivery'; });
    });

    function eta() {
      var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Asia/Dubai' }); };
      var a = new Date(Date.now() + 864e5), b = new Date(Date.now() + 3 * 864e5);
      return fmt(a) + ' – ' + fmt(b);
    }
    function showDone(o, body) {
      var done = $('[data-vd-done]', root);
      var set = function (k, v) { var e = $('[data-d="' + k + '"]', done); if (e) e.textContent = v; };
      var totalCents = Math.round(parseFloat(o.total) * 100);
      set('first', body.name.split(' ')[0]); set('phone', o.phone || body.phone); set('name', o.name);
      set('title', P.title); set('qty', (P.defaultOnly ? '' : variant.title + ' · ') + (tier ? tier.label : 'Qty ' + body.quantity));
      set('total', aed(totalCents)); set('total2', aed(totalCents)); set('to', o.deliverTo); set('eta', eta());
      var im = $('[data-d="img"]', done); if (im) im.src = variant.image || P.image;
      var wa = $('[data-d="wa"]', done);
      if (wa) wa.href = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent('Hi, I have a question about my order ' + o.name + '.');
      closeSheet();
      done.hidden = false; document.documentElement.classList.add('vd-lock'); done.scrollTop = 0;
      confetti($('[data-vd-confetti]', done));
      if (window.vdTrack) window.vdTrack('Purchase', Object.assign(vdItem(+body.quantity), { value: totalCents / 100, transaction_id: o.name, order_id: o.id, event_id: o.event_id || body.event_id }));
    }
    function confetti(t) {
      if (!t || t._c) return; t._c = 1;
      var cols = ['#FFFFFF', '#D9480F', '#BFDDD5', '#FFFFFF', '#8CC7BC', '#D9480F'], seed = 7;
      var r = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
      for (var i = 0; i < 30; i++) {
        var e = document.createElement('i'); e.className = 'vd-cf';
        var w = 4 + r() * 6, h = w * (r() > .5 ? 2.2 : 1), x, y;
        do { x = r() * 100; y = r() * 100; } while (!((y < 48 && (x < 30 || x > 70)) || x < 7 || x > 93));
        e.style.cssText = 'left:' + x + '%;top:' + y + '%;width:' + w + 'px;height:' + h + 'px;background:' + cols[i % 6] + ';transform:rotate(' + (r() * 180) + 'deg);opacity:' + (.55 + r() * .45) + ';' + (r() > .6 ? 'border-radius:50%' : '');
        t.appendChild(e);
      }
    }
    render();
  }

  /* ================= v6: navigation + interactivity ================= */
  var closeSearch = null;
  var UAE_OFF = 4 * 3600e3, DAY = 864e5;
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function initSearch() {
    var so = $('[data-vd-so]'); if (!so || so._vd) return; so._vd = 1;
    var inp = $('[data-vd-so-in]', so), res = $('[data-vd-so-res]', so), pop = $('[data-vd-so-pop]', so), t = null, ctl = null, last = '';
    function open() {
      so.hidden = false; document.documentElement.classList.add('vd-lock');
      requestAnimationFrame(function () { so.classList.add('is-open'); });
      setTimeout(function () { inp.focus(); }, 30);
    }
    closeSearch = function () {
      if (so.hidden) return;
      so.classList.remove('is-open'); document.documentElement.classList.remove('vd-lock');
      setTimeout(function () { so.hidden = true; }, reduceMotion ? 0 : 200);
    };
    $$('[data-vd-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-vd-search-close]', so).forEach(function (b) { b.addEventListener('click', closeSearch); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
    function run(q) {
      if (q === last) return; last = q;
      if (q.length < 2) { res.innerHTML = ''; pop.hidden = false; return; }
      if (ctl && ctl.abort) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
        var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        pop.hidden = true;
        if (!ps.length) { res.innerHTML = '<p class="vd-so__none">No matches for “' + esc(q) + '”. Try a shorter word.</p>'; return; }
        res.innerHTML = '<ul class="vd-so__list">' + ps.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : (p.image || '');
          var pr = parseFloat(p.price), cp = parseFloat(p.compare_at_price_max || 0), off = cp > pr ? Math.floor((cp - pr) * 100 / cp) : 0;
          return '<li><a href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt="" width="52" height="52" loading="lazy"><span><b>' + esc(p.title) + '</b><em>' + aed(Math.round(pr * 100)) + (off ? ' <i>-' + off + '%</i>' : '') + '</em></span></a></li>';
        }).join('') + '</ul><a class="vd-so__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
      }).catch(function () {});
    }
    inp.addEventListener('input', function () { clearTimeout(t); var q = inp.value.trim(); t = setTimeout(function () { run(q); }, 180); });
  }

  function initHeaderScroll() {
    var h = $('[data-vd-header]'), top = $('[data-vd-top]'); if (!h || h._vds) return; h._vds = 1;
    var lastY = window.scrollY, tick = false;
    function upd() {
      tick = false; var y = window.scrollY;
      h.classList.toggle('is-min', y > 140 && y > lastY);
      if (y < 60) h.classList.remove('is-min');
      h.classList.toggle('is-scrolled', y > 8);
      if (top) { var show = y > window.innerHeight * 1.5; if (show === top.hidden) top.hidden = !show; }
      lastY = y;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    upd();
    // keep the active chip visible
    $$('[data-vd-chips]').forEach(function (c) { var a = $('.is-on', c); if (a && a.offsetLeft > c.clientWidth * 0.6) c.scrollLeft = a.offsetLeft - 16; });
  }

  function initReveal() {
    var els = $$('[data-reveal]:not(.is-in)');
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    document.documentElement.classList.add('vd-rv');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (e, i) {
      var sib = e.parentNode ? Array.prototype.indexOf.call(e.parentNode.children, e) : 0;
      e.style.setProperty('--rd', Math.min(sib % 4, 3) * 70 + 'ms');
      io.observe(e);
    });
    // never leave content hidden (e.g. print / odd browsers)
    setTimeout(function () { $$('[data-reveal]:not(.is-in)').forEach(function (e) { if (e.getBoundingClientRect().top < window.innerHeight) e.classList.add('is-in'); }); }, 1500);
  }

  function uaeDay() { return Math.floor((Date.now() + UAE_OFF) / DAY); }
  function initCountdown() {
    var cds = $$('[data-vd-cd]'); if (!cds.length || initCountdown._t) return;
    function tick() {
      var left = DAY - ((Date.now() + UAE_OFF) % DAY), s = Math.floor(left / 1000);
      var txt = [Math.floor(s / 3600), Math.floor(s / 60) % 60, s % 60].map(function (n) { return (n < 10 ? '0' : '') + n; }).join(':');
      cds.forEach(function (c) { var b = $('[data-vd-cd-t]', c); if (b) b.textContent = txt; });
    }
    tick(); initCountdown._t = setInterval(tick, 1000);
  }
  function initDealOfDay() {
    $$('[data-vd-dotd]').forEach(function (w) {
      if (w._vd) return; w._vd = 1;
      var s = $$('.vd-dotd__s', w); if (s.length < 2) return;
      var k = uaeDay() % s.length;
      s.forEach(function (e, i) { e.hidden = i !== k; e.classList.toggle('is-on', i === k); });
    });
  }

  function initCarousels() {
    $$('[data-vd-car]').forEach(function (c) {
      if (c._vd) return; c._vd = 1;
      var t = $('.vd-car__t', c), p = $('.vd-car__b--p', c), n = $('.vd-car__b--n', c);
      function upd() { if (!p) return; p.disabled = t.scrollLeft < 8; n.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8; c.classList.toggle('no-ov', t.scrollWidth <= t.clientWidth + 4); }
      $$('.vd-car__b', c).forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.getAttribute('data-dir') * t.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' }); }); });
      t.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd); upd();
    });
  }

  function initSort() {
    $$('[data-vd-sort]').forEach(function (s) {
      if (s._vd) return; s._vd = 1;
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
    });
  }

  /* quick view: fetch /products/<handle>.js, swipe images, pick a variant, go straight to the COD form */
  var qv = null;
  function initQuickView() {
    if (initQuickView._vd) return; initQuickView._vd = 1;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-vd-qv]'); if (!b) return;
      e.preventDefault(); openQV(b.getAttribute('data-vd-qv'), b);
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-vd-card-buy]'); if (!a || reduceMotion) return;
      a.classList.add('is-tap');
    });
  }
  function openQV(handle, opener) {
    if (!qv) {
      qv = document.createElement('div'); qv.className = 'vd-qv'; qv.hidden = true;
      qv.setAttribute('role', 'dialog'); qv.setAttribute('aria-modal', 'true'); qv.setAttribute('aria-label', 'Quick view');
      qv.innerHTML = '<div class="vd-qv__ov" data-qv-x></div><div class="vd-qv__p"><button class="vd-x vd-qv__x" type="button" data-qv-x aria-label="Close"><svg class="vd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button><div class="vd-qv__c" data-qv-c></div></div>';
      document.body.appendChild(qv);
      qv.addEventListener('click', function (e) { if (e.target.closest('[data-qv-x]')) closeQV(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qv && !qv.hidden) closeQV(); });
    }
    qv._opener = opener;
    var c = $('[data-qv-c]', qv);
    c.innerHTML = '<div class="vd-qv__load"><i></i><i></i><i></i></div>';
    qv.hidden = false; document.documentElement.classList.add('vd-lock');
    requestAnimationFrame(function () { qv.classList.add('is-open'); });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
      var v = p.variants.filter(function (x) { return true; })[0] || p.variants[0];
      var imgs = (p.images || []).slice(0, 8).map(function (u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=700'; });
      var many = p.variants.length > 1 && p.variants.length <= 30;
      c.innerHTML =
        '<div class="vd-qv__g" data-qv-g>' + imgs.map(function (u, i) { return '<img src="' + esc(u) + '" alt="' + (i ? '' : esc(p.title)) + '" loading="' + (i ? 'lazy' : 'eager') + '" width="700" height="700">'; }).join('') + '</div>' +
        (imgs.length > 1 ? '<div class="vd-qv__dots" data-qv-dots>' + imgs.map(function (u, i) { return '<i' + (i ? '' : ' class="is-on"') + '></i>'; }).join('') + '</div>' : '') +
        '<div class="vd-qv__tx"><h3>' + esc(p.title) + '</h3><div class="vd-price vd-price--lg" data-qv-pr></div>' +
        (many ? '<div class="vd-qv__vs" data-qv-vs>' + p.variants.map(function (x) { return '<button type="button" data-id="' + x.id + '"' + (true ? '' : ' disabled') + (x.id === v.id ? ' class="is-on"' : '') + '>' + esc(x.title) + '</button>'; }).join('') + '</div>' : '') +
        '<a class="vd-btn vd-qv__buy" data-qv-buy href="#">Buy Now - Cash on Delivery</a><a class="vd-qv__more" data-qv-more href="#">See full details</a></div>';
      function paint() {
        var off = v.compare_at_price > v.price ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        $('[data-qv-pr]', c).innerHTML = '<b class="vd-sale">' + aed(v.price) + '</b>' + (off ? '<s>' + aed(v.compare_at_price) + '</s><span class="vd-off">-' + off + '%</span>' : '');
        var buy = $('[data-qv-buy]', c);
        buy.href = p.url + '?variant=' + v.id + '#buy'; buy.classList.toggle('is-off', false); buy.textContent = true ? 'Buy Now - Cash on Delivery' : 'Sold out';
        $('[data-qv-more]', c).href = p.url + '?variant=' + v.id;
        $$('[data-qv-vs] button', c).forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-id') === v.id); });
      }
      $$('[data-qv-vs] button', c).forEach(function (b) { b.addEventListener('click', function () {
        v = p.variants.filter(function (x) { return x.id === +b.getAttribute('data-id'); })[0] || v; paint();
        if (v.featured_image && v.featured_image.position) { var g = $('[data-qv-g]', c); g.scrollTo({ left: (v.featured_image.position - 1) * g.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }
      }); });
      var g = $('[data-qv-g]', c), dots = $$('[data-qv-dots] i', c);
      g.addEventListener('scroll', function () { var n = Math.round(g.scrollLeft / g.clientWidth); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); }); }, { passive: true });
      paint();
      var x = $('.vd-qv__x', qv); x && x.focus({ preventScroll: true });
    }).catch(function () {
      c.innerHTML = '<p class="vd-qv__err">Couldn\u2019t load this product. <a href="' + root + 'products/' + encodeURIComponent(handle) + '">Open it</a></p>';
    });
  }
  function closeQV() {
    if (!qv) return; qv.classList.remove('is-open'); document.documentElement.classList.remove('vd-lock');
    setTimeout(function () { qv.hidden = true; }, reduceMotion ? 0 : 200);
    qv._opener && qv._opener.focus && qv._opener.focus({ preventScroll: true });
  }

  function initTicker() {
    $$('[data-vd-tk]').forEach(function (t) {
      var c = $('[data-vd-tk-c]', t); if (!c || t._vd) return; t._vd = 1;
      var sets = $$('.vd-tk__s', c), base = sets[0].innerHTML;
      if (!base.trim()) return;
      // repeat the lines until one set is wider than the screen so the loop never shows a gap
      var guard = 0;
      while (sets[0].scrollWidth < window.innerWidth + 40 && guard++ < 8) { sets.forEach(function (s) { s.insertAdjacentHTML('beforeend', base); }); }
      $$('.vd-tk__i', sets[1]).forEach(function (i) { i.removeAttribute('data-shopify-editor-block'); });
      var speed = parseFloat(getComputedStyle(t).getPropertyValue('--tk-speed')) || 35;
      if (window.innerWidth >= 750) speed *= 1.3;
      c.style.animationDuration = (sets[0].getBoundingClientRect().width / speed).toFixed(1) + 's';
      t.classList.add('is-ready');
    });
  }
  function initV6() { initTicker(); initSearch(); initHeaderScroll(); initReveal(); initCountdown(); initDealOfDay(); initCarousels(); initSort(); initQuickView(); }

  function init() { initDrawer(); initRotator(); initHero(); initPdp(); initV6(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
